import { render, staticRenderFns } from "./PacienteDatosVertical.vue?vue&type=template&id=169cd1ac&scoped=true"
import script from "./PacienteDatosVertical.vue?vue&type=script&lang=js"
export * from "./PacienteDatosVertical.vue?vue&type=script&lang=js"
import style0 from "./PacienteDatosVertical.vue?vue&type=style&index=0&id=169cd1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169cd1ac",
  null
  
)

export default component.exports